var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.themeData.title)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.themeData.title)+" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }